import ApiService from "@/common/api.service";
import { SET_ERROR } from "./mutations.type";

const state = {
    signboard: {},
    signboards: {}
}

const getters = {
    signboard() {
        return state.signboard
    },
    signboards() {
        return state.signboards
    }
}

const actions = {
    async fetchSignboard(context, signboardSlug) {
        return new Promise(resolve => {
            ApiService.get("signboard", signboardSlug)
                .then(({ data }) => {
                    context.commit("setSignboard", data);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response.data.errors);
                });
        });
    },
    async fetchSignboards(context) {
        return new Promise(resolve => {
            ApiService.get("signboard")
                .then(({ data }) => {
                    context.commit("setSignboards", data);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response.data.errors);
                });
        });
    },
    async ImageUpload(context, file) {
        return new Promise((resolve, reject) => {
            var filename = "signboard0"
            const formData = new FormData()
            formData.append('file', file)
            ApiService.post("file/image/" + filename, formData, {headers: {
                'Content-Type': 'multipart/form-data'
            }})
                .then(({ data }) => {
                    state.signboard.icon = data;
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response.data.errors);
                    reject('圖片上傳失敗!'+response.data.errors);
                });
        });
    },
    async signboardEdit(context) {
        return new Promise(resolve => {
            ApiService.update("signboard", state.signboard)
                .then(({ data }) => {
                    context.commit("setSignboard", data);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response.data.errors);
                });
        });
    },
    async signboardCreate(context) {
        return new Promise(resolve => {
            ApiService.post("signboard", state.signboard)
                .then(({ data }) => {
                    context.commit("setSignboard", data);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response.data.errors);
                });
        });
    }
}

const mutations = {
    setSignboard(state, signboard) {
        state.signboard = signboard
    },
    setSignboards(state, signboards) {
        state.signboards = signboards
    }
}

export default {
    state,
    getters,
    actions,
    mutations
};
